import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getOtherMaterialReceiveDetail, getOtherMaterialRefundList } from '../api/index.js';
export default {
  name: 'MaterialReceiveViewDrawer',
  props: {
    id: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      refundLoading: false,
      form: {
        user_name: '',
        apply_date: '',
        remark: ''
      },
      dataList: [],
      refundList: [],
      refundSearchPage: {
        page: 1,
        pagesize: 20
      },
      refundPages: {}
    };
  },
  created: function created() {
    this.getDetail();
    this.getRefundList();
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;
      this.loading = true;
      getOtherMaterialReceiveDetail({
        id: this.id
      }).then(function (res) {
        var info = res.data && res.data.user_info || {};
        _this.form.user_name = info.user_name || '';
        _this.form.date = info.date || '';
        _this.form.remark = info.remark || '';
        _this.dataList = res.data.list;
      }).catch(function () {
        _this.$message.error('详情加载失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    getRefundList: function getRefundList() {
      var _this2 = this;
      this.refundLoading = true;
      var params = _objectSpread({
        receive_id: this.id
      }, this.refundSearchPage);
      getOtherMaterialRefundList(params).then(function (res) {
        _this2.refundList = _this2.flattenList(res.data.list || []);
        _this2.refundPages = res.pages || {};
      }).catch(function () {
        _this2.$message.error('退还明细加载失败');
      }).finally(function () {
        _this2.refundLoading = false;
      });
    },
    refundCurrentChange: function refundCurrentChange(val) {
      this.refundSearchPage.page = val;
      this.getRefundList();
    },
    refundSizeChange: function refundSizeChange(val) {
      this.refundSearchPage.pagesize = val;
      this.refundSearchPage.page = 1;
      this.getRefundList();
    },
    flattenList: function flattenList(list) {
      var rows = [];
      (list || []).forEach(function (item) {
        var parentKey = item.code || item.id || '';
        var materials = Array.isArray(item.material_items) && item.material_items.length ? item.material_items : [{}];
        materials.forEach(function (m, idx) {
          rows.push(_objectSpread(_objectSpread(_objectSpread({}, item), m), {}, {
            _rowKey: "".concat(parentKey, "_").concat(m.id || '', "_").concat(m.material_id || '', "_").concat(idx),
            _parentKey: parentKey,
            _parentSize: materials.length,
            _rowIndexInParent: idx
          }));
        });
      });
      return rows;
    },
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
        column = _ref.column;
      var outerProps = ['id', 'code', 'created_at', 'updated_user_name', 'remark'];
      var isOuter = outerProps.includes(column.property);
      if (isOuter) {
        if (row._rowIndexInParent === 0) {
          return {
            rowspan: row._parentSize,
            colspan: 1
          };
        }
        return {
          rowspan: 0,
          colspan: 0
        };
      }
      return {
        rowspan: 1,
        colspan: 1
      };
    },
    handleClose: function handleClose() {
      this.$emit('close');
    }
  }
};